import type { RegisterParams } from '@common/workflow/serviceActivityRegistry';
import { CustomControlCode } from '@common/enums';
import { ServiceActivityRegistry } from '@common/workflow/serviceActivityRegistry';
import { lumbarRadiculopathyAssessmentSections } from './lumbarRadiculopathyAssessment/lumbarRadiculopathyAssessment';
import { lumbarRadiculopathyExaminationSections } from './lumbarRadiculopathyExamination/lumbarRadiculopathyExamination';
import { lumbarRadiculopathyReferralSections } from './lumbarRadiculopathyReferral/lumbarRadiculopathyReferral';

const registryElements: RegisterParams[] = [
    {
        customControlCode: CustomControlCode.LumbarRadiculopathyAssessment,
        sections: lumbarRadiculopathyAssessmentSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.LumbarRadiculopathyExamination,
        sections: lumbarRadiculopathyExaminationSections,
        version: 1,
    },
    {
        customControlCode: CustomControlCode.LumbarRadiculopathyReferral,
        sections: lumbarRadiculopathyReferralSections,
        version: 1,
    },
];

ServiceActivityRegistry.instance.registerAll(registryElements);
